import {
  ISelectedTravellers,
  ISTERMINAL,
  ITraveller,
  WAITINGLIST
} from '../../../../../../../../../../data/api/models';
import { forEach, get } from 'lodash';
import { Field } from 'redux-form';
import FieldFormControl from '../../../../../../../../../../components/FieldFormControl';
import { useEffect, useState } from 'react';
import React = require('react');
import { mtaMedicalDeclarationQuestionAnswers } from '../../../../../../Helpers';

interface ISelectTraveller {
  travellers: ITraveller[];

  selectedTravellers: ISelectedTravellers
  change: (field, value) => void
  formValues: any;
  isTerminal: boolean;
  isWaitingList: boolean;
}

export const SelectTraveller = ({
                                  travellers,
                                  selectedTravellers,
                                  change,
                                  formValues,
                                  isTerminal,
                                  isWaitingList,
                                }: ISelectTraveller) => {

  const [showSelection, setShowSelection] = useState(false);
  const [question, setQuestion] = useState(null);

  const criticalAnswers = mtaMedicalDeclarationQuestionAnswers(formValues)

  const resetTravellerQuestion = (question) => {
    forEach(travellers, (traveller, index) => {
      change(`data.attributes.travellers.${index}.metadata.medicalQuestions.${question}`, false)
    })
  }

  useEffect(() => {

    if (isWaitingList) {

      if (criticalAnswers.waitingListAnswer) {
        setShowSelection(true);
        setQuestion(WAITINGLIST);
      }

      if (!criticalAnswers.waitingListAnswer) {
        change('selectedTravellers.waitingList', []);
        resetTravellerQuestion(WAITINGLIST)
        setShowSelection(false);
        setQuestion(null);
      }
    }

    if (isTerminal) {

      if (criticalAnswers.terminalAnswer) {
        setShowSelection(true);
        setQuestion(ISTERMINAL);
      }

      if (!criticalAnswers.terminalAnswer) {
        change('selectedTravellers.isTerminal', []);
        resetTravellerQuestion(ISTERMINAL)
        setShowSelection(false);
        setQuestion(null);
      }
    }

  }, [criticalAnswers.waitingListAnswer, criticalAnswers.terminalAnswer])

  let fieldName = '';
  let travellersQuestionSelection = [];

  if (!showSelection) {
    return null;
  }

  switch (question) {
    case WAITINGLIST:
      fieldName = 'selectedTravellers.waitingList'
      travellersQuestionSelection = get(selectedTravellers, WAITINGLIST, [])
      break;
    case ISTERMINAL:
      fieldName = 'selectedTravellers.isTerminal'
      travellersQuestionSelection = get(selectedTravellers, ISTERMINAL, [])
      break;
  }

  const onchangeValue = (travellerId: string) => (e) => {
    if (!fieldName) {
      return;
    }

    let travellersSelected = [...travellersQuestionSelection];
    if (e.target.checked) {
      travellersSelected.push(travellerId);
      change(fieldName, travellersSelected)
    } else {
      travellersSelected = travellersSelected.filter(d => d !== travellerId);
      change(fieldName, travellersSelected)
    }
  }

  let title;

  if (isWaitingList) {
    title = 'Please select the traveller(s) on a waiting list.'
  }

  if (isTerminal) {
    title = 'Please select the traveller(s) with a terminal condition.'
  }

  return (
    <>
      <div style={{ marginBottom: '10px' }}>
        {title}
      </div>
      <div>
        {travellers.map((traveller, index) => {
          return (
            <div key={index}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>{traveller.title} {traveller.firstName} {traveller.lastName}</div>
                <div style={{ flex: 1 }}>
                  <Field
                    name={`data.attributes.travellers.${index}.metadata.medicalQuestions.${question}`}
                    type="checkbox"
                    value="true"
                    component={FieldFormControl}
                    onChange={onchangeValue(traveller.id)}>{''}
                    <div/>
                  </Field>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  )
}
